import { Item } from "dsabp-js"
import { createCanvas } from "../canvas.js"
import { rendererResolvers } from "../main.js"
import { getImage, putInCanvas, toImage } from "../util.js"

rendererResolvers.push(
	({ item }) => {
		if (item != Item.SHIELD_GENERATOR)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const canvas = createCanvas(0, 0)
				const ctx = canvas.getContext("2d")

				const imgGen = await getImage(item.buildInfo[0].image)
				const imgMatrix = await getImage("shield_matrix_idle")

				putInCanvas(canvas, ctx, imgGen)

				ctx.drawImage(imgMatrix,
					imgGen.width / 2 - imgMatrix.width / 2,
					imgGen.height / 2 - imgMatrix.height / 2
				)

				return [{ image: await toImage(canvas) }]
			}
		}
	}
)
